import { memo, useState, useRef, useEffect } from "react";
import getFinishTime from "utils/getFinishTime";
import { Time } from "../styledComponents";
import { getDistance } from "../utils/util";

const Timer = ({
  started,
  duration,
}: {
  started: number;
  duration: number;
}) => {
  const [finishIn, setFinishIn] = useState(getFinishTime(started, duration));
  const [activeTime, setActiveTime] = useState(getDistance(finishIn));
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setFinishIn(getFinishTime(started, duration));
  }, [started, duration]);

  useEffect(() => {
    setActiveTime(getDistance(finishIn));
  }, [finishIn]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActiveTime(getDistance(finishIn));
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [finishIn]);

  return (
    <Time>
      {!activeTime.includes("-") ? activeTime : "00:00"} до окончания теста
    </Time>
  );
};

export default memo(Timer);
